/**
 * Riwayat kata kunci pencarian (search history), disimpan di localStorage
 * (bukan cookie/server) - lihat pola yang sama di single-product.js untuk
 * riwayat produk dilihat. Ditampilkan di bawah tiap form pencarian: dropdown
 * mega-style desktop (.nav-search-form, blocks/block-navigation.php) dan
 * offcanvas mobile/tablet (.dufeng-offcanvas-search-form,
 * blocks/block-offcanvas-search.php). Markup wadahnya (.search-history)
 * dirender kosong dari PHP sebagai sibling langsung tiap form, lalu diisi di
 * sini karena riwayatnya murni per-browser, tidak bisa di-render server-side.
 */

var SEARCH_HISTORY_KEY = "dufeng_search_history";
var SEARCH_HISTORY_MAX = 8;

function readSearchHistory() {
  try {
    var raw = window.localStorage.getItem(SEARCH_HISTORY_KEY);
    if (!raw) return [];
    var terms = JSON.parse(raw);
    return Array.isArray(terms)
      ? terms.filter(function (term) {
          return typeof term === "string" && term.trim() !== "";
        })
      : [];
  } catch (e) {
    return [];
  }
}

function rememberSearchTerm(term) {
  term = (term || "").trim();
  if (!term) return;

  try {
    var terms = readSearchHistory().filter(function (existing) {
      return existing.toLowerCase() !== term.toLowerCase();
    });
    terms.unshift(term);
    window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(terms.slice(0, SEARCH_HISTORY_MAX)));
  } catch (e) {
    /* localStorage penuh atau diblokir: riwayat dilewati saja */
  }
}

function forgetSearchTerm(term) {
  try {
    var terms = readSearchHistory().filter(function (existing) {
      return existing.toLowerCase() !== term.toLowerCase();
    });
    window.localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(terms));
  } catch (e) {
    /* ignore */
  }
}

function renderSearchHistory(container, input) {
  var terms = readSearchHistory();

  container.innerHTML = "";
  container.hidden = terms.length === 0;
  if (!terms.length) return;

  var label = document.createElement("div");
  label.className = "search-history__label";
  label.textContent = "Pencarian Terakhir";
  container.appendChild(label);

  terms.forEach(function (term) {
    var item = document.createElement("div");
    item.className = "search-history__item";

    var termBtn = document.createElement("button");
    termBtn.type = "button";
    termBtn.className = "search-history__term";
    termBtn.textContent = term;
    termBtn.addEventListener("click", function () {
      input.value = term;
      var form = input.closest("form");
      if (form) {
        rememberSearchTerm(term);
        form.submit();
      }
    });

    var removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "search-history__remove";
    removeBtn.setAttribute("aria-label", 'Hapus "' + term + '" dari riwayat pencarian');
    removeBtn.innerHTML = "&times;";
    removeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      forgetSearchTerm(term);
      renderSearchHistory(container, input);
    });

    item.appendChild(termBtn);
    item.appendChild(removeBtn);
    container.appendChild(item);
  });
}

function initSearchHistoryForm(form) {
  var container = form.parentElement?.querySelector(":scope > .search-history");
  var input = form.querySelector('input[name="s"]');
  if (!container || !input) return;

  renderSearchHistory(container, input);

  form.addEventListener("submit", function () {
    rememberSearchTerm(input.value);
    // Navigasi form tetap jalan normal (bukan AJAX); localStorage.setItem
    // sinkron, jadi riwayatnya sudah tersimpan sebelum browser pindah halaman.
  });
}

export function initSearchHistory() {
  document.querySelectorAll(".nav-search-form, .dufeng-offcanvas-search-form").forEach(function (form) {
    initSearchHistoryForm(form);
  });
}
